import { SharedVersion, ModuleShare, ModuleShareModule, Space, Maybe } from "types/generated";

export enum SharedModuleType {
  SPACE = "Space",
  ACCOUNT = "Account",
}

export type SharedModuleData = Pick<ModuleShare, "id" | "from" | "to"> & {
  module: Pick<ModuleShareModule, "description" | "name" | "id"> & {
    latest: Pick<SharedVersion, "id"> | null;
    current: Pick<SharedVersion, "id" | "number" | "state" | "yanked"> | null;
  };
};

export type SharedModuleDataWithSpace = Pick<ModuleShareModule, "description" | "name" | "id"> & {
  latest: Pick<SharedVersion, "id"> | null;
  current: Pick<SharedVersion, "id" | "number" | "state" | "yanked"> | null;
  space?: Maybe<Space>;
  spaces?: Maybe<Space[]>; // when shared to multiple spaces
  type: SharedModuleType;
};

export type SharedModuleDataWithAccount = Pick<ModuleShareModule, "description" | "name" | "id"> & {
  latest: Pick<SharedVersion, "id"> | null;
  current: Pick<SharedVersion, "id" | "number" | "state" | "yanked"> | null;
  subdomain?: string;
  type: SharedModuleType;
};

export type ModuleSortableFields = "type" | "name";
